var _ = require('underscore');
var TorsoService = require('backbone-torso/modules/ServiceCell');

var PAYMENT_ERRORS = {
  NO_DATA: 'noData',
  TIMEOUT: 'timeout',
  PAYMENT_ERROR: 'paymentError',
  PAYMENT_CANCELED : 'paymentCanceled',
  UNKNOWN_STATUS: 'unknownStatus'
};

var DEVICE_SCAN_STATUS = {
  /**
   * Phase 1: No Scan has been performed. (do not show option for device payment)
   */
  NOT_SCANNED: 'NOT_SCANNED',
  /**
   * Phase 1: Checking if any device is selected. (do not show option for device payment)
   */
  GETTING_SELECTED_DEVICE: 'GETTING_SELECTED_DEVICE',
  /**
   * Phase 1: No device is selected. (do not show option for device payment)
   */
  NO_DEVICE_SELECTED: 'NO_DEVICE_SELECTED',
  /**
   * Phase 1: Checking if device is selected errored. (do not show option for device payment)
   */
  GETTING_SELECTED_DEVICE_ERROR: 'GETTING_SELECTED_DEVICE_ERROR',
  /**
   * Phase 1: Checking if device is selected was canceled by the user. (do not show option for device payment)
   */
  GETTING_SELECTED_DEVICE_CANCELED: 'GETTING_SELECTED_DEVICE_CANCELED',
  /**
   * Phase 1: Checking if device is selected timed out. (do not show option for device payment)
   */
  GETTING_SELECTED_DEVICE_TIMEOUT: 'GETTING_SELECTED_DEVICE_TIMEOUT',
  /**
   * Phase 2: Validating the selected device. (show disabled option for device payment with scanning... message)
   */
  CHECKING_IF_DEVICE_IS_ABLE_TO_PAY: 'CHECKING_IF_DEVICE_IS_ABLE_TO_PAY',
  /**
   * Phase 2: Device is selected but we could not validate it. (show disabled option for device payment with retry message)
   */
  DEVICE_NOT_ABLE_TO_PAY: 'DEVICE_NOT_ABLE_TO_PAY',
  /**
   * Phase 2: Device is selected and validated. (show option for device payment with no qualifying message)
   */
  DEVICE_ABLE_TO_PAY: 'DEVICE_ABLE_TO_PAY',
  /**
   * Phase 2: Device is selected but validating errored. (show disabled option for device payment with retry message)
   */
  CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_ERROR: 'CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_ERROR',
  /**
   * Phase 2: Device is selected but validating was canceled by the user. (show disabled option for device payment with retry message)
   */
  CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_CANCELED: 'CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_CANCELED',
  /**
   * Phase 2: Device is selected but validating timed out. (show disabled option for device payment with retry message)
   */
  CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT: 'CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT'
};

/* jshint ignore:start */
var DEVICE_PAYMENT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELED: 'CANCELED',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR',
  TIMEOUT: 'TIMEOUT'
};

/* Polling interval in ms */
var POLLING_INTERVAL = 250;
/**
 * Polling timeout in ms
 * Polling timeout cannot be equal to DEVICE_PAYMENT_TIMEOUT_MS as introduces a race condition
 * Polling timeout should be longer than DEVICE_PAYMENT_TIMEOUT_MS to ensure that the device payment application exits correctly
 */
var DEVICE_PAYMENT_POLLING_TIMEOUT_MS = 31000;

/**
 * Device payment timeout in ms
 * Device payment timeout cannot be equal to DEVICE_PAYMENT_POLLING_TIMEOUT_MS as introduces a race condition
 *
 * TO-DO : Make IOS Ereg Launchers respect this value.
 * Timeout is currently handled by a hardcoded value in IOS rather than the passed DEVICE_PAYMENT_TIMEOUT_MS in the Ereg Launchers
 * (There is some misleading code that might make it appear to be used when passed through startDevicePayment)
 * ((I believe that Android Ereg Launcher is now respecting this value.))
 */
var DEVICE_PAYMENT_TIMEOUT_MS = 30000;

/**
 * Device Status Polling timeout in ms
 * Device Status Polling timeout cannot be equal to DEVICE_STATUS_TIMEOUT_MS as introduces a race condition
 * Device Status Polling timeout should be longer than DEVICE_STATUS_TIMEOUT_MS to ensure that the device payment application exits correctly
 */
var DEVICE_STATUS_POLLING_TIMEOUT_MS = 11000;

/**
 * Device status timeout in ms
 * Device status timeout cannot be equal to DEVICE_PAYMENT_POLLING_TIMEOUT_MS as introduces a race condition
 *
 * TO-DO : Make IOS Ereg Launchers respect this value.
 * Timeout is currently handled by a hardcoded value in IOS rather than the passed DEVICE_PAYMENT_TIMEOUT in the Ereg Launchers
 * (There is some misleading code that might make it appear to be used when passed through startDevicePayment)
 * ((I believe that Android Ereg Launcher is now respecting this value.))
 */
var DEVICE_STATUS_TIMEOUT_MS = 10000;

/**
 * @param [...args] {String[]} any strings passed in will be validated as functions of the interface.
 * @return {boolean} True if DevicePaymentJavascriptInterface is globally defined and all arguments are names of functions defined by it.
 */
function doesDevicePaymentJavascriptInterfaceExist() {
  try {
    if (_.isUndefined(DevicePaymentJavascriptInterface)) {
      return false;
    }
    for(var functionToValidateIndex = 0; functionToValidateIndex < arguments.length; functionToValidateIndex++) {
      var functionToValidateName = arguments[functionToValidateIndex];
      var functionToValidate = DevicePaymentJavascriptInterface[functionToValidateName];
      if (!_.isFunction(functionToValidate)) {
        return false;
      }
    }
    return true;
  } catch (interfaceExistsError) {
    if (interfaceExistsError instanceof ReferenceError) {
      return false;
    }
    throw interfaceExistsError;
  }
}
/* jshint ignore:end */

/**
 * Singleton service for managing the device payment integration
 *
 * @class paymentDataDeviceService
 * @static
 * @extends Torso.ServiceCell
 */
var paymentDataDeviceService = new (TorsoService.extend({

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, 'startDevicePaymentAndPolling',
      '_setMockDevicePaymentInfo', '_setMockDevicePaymentCanceled', '_setMockDevicePaymentTimeout', '_setMockDevicePaymentErrored',
      '_pollForPayment', '_timeout',
      '_setMockDeviceStatus',
      '_setMockDeviceStatusNotScanned', '_setMockDeviceStatusNoDeviceSelected', '_setMockDeviceStatusGettingSelectedDevice',
      '_setMockDeviceStatusGettingSelectedDeviceError', '_setMockDeviceStatusGettingSelectedDeviceCanceled', '_setMockDeviceStatusGettingSelectedDeviceTimeout',
      '_setMockDeviceStatusCheckingIfDeviceIsAbleToPay', '_setMockDeviceStatusDeviceNotAbleToPay', '_setMockDeviceStatusDeviceAbleToPay',
      '_setMockDeviceStatusCheckingIfDeviceIsAbleToPayError', '_setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled', '_setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout',
      '_statusPoll', '_statusTimeout',
      '_timeoutMock');
    window.setMockDevicePaymentInfo = this._setMockDevicePaymentInfo;
    window.setMockDevicePaymentCanceled = this._setMockDevicePaymentCanceled;
    window.setMockDevicePaymentTimeout = this._setMockDevicePaymentTimeout;
    window.setMockDevicePaymentErrored = this._setMockDevicePaymentErrored;
    window.setMockDeviceStatus = this._setMockDeviceStatus;
    window.setMockDeviceStatusNotScanned = this._setMockDeviceStatusNotScanned;
    window.setMockDeviceStatusGettingSelectedDevice = this._setMockDeviceStatusGettingSelectedDevice;
    window.setMockDeviceStatusGettingSelectedDeviceError = this._setMockDeviceStatusGettingSelectedDeviceError;
    window.setMockDeviceStatusGettingSelectedDeviceCanceled = this._setMockDeviceStatusGettingSelectedDeviceCanceled;
    window.setMockDeviceStatusGettingSelectedDeviceTimeout = this._setMockDeviceStatusGettingSelectedDeviceTimeout;
    window.setMockDeviceStatusNoDeviceSelected = this._setMockDeviceStatusNoDeviceSelected;
    window.setMockDeviceStatusCheckingIfDeviceIsAbleToPay = this._setMockDeviceStatusCheckingIfDeviceIsAbleToPay;
    window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayError = this._setMockDeviceStatusCheckingIfDeviceIsAbleToPayError;
    window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled = this._setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled;
    window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout = this._setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout;
    window.setMockDeviceStatusDeviceNotAbleToPay = this._setMockDeviceStatusDeviceNotAbleToPay;
    window.setMockDeviceStatusDeviceAbleToPay = this._setMockDeviceStatusDeviceAbleToPay;
  },

  /**
   * Clean up global methods.
   * @private
   */
  _dispose: function() {
    delete window.setMockDevicePaymentInfo;
    delete window.setMockDevicePaymentCanceled;
    delete window.setMockDevicePaymentTimeout;
    delete window.setMockDevicePaymentErrored;
    delete window.setMockDeviceStatus;
    delete window.setMockDeviceStatusNotScanned;
    delete window.setMockDeviceStatusGettingSelectedDevice;
    delete window.setMockDeviceStatusGettingSelectedDeviceError;
    delete window.setMockDeviceStatusGettingSelectedDeviceCanceled;
    delete window.setMockDeviceStatusGettingSelectedDeviceTimeout;
    delete window.setMockDeviceStatusNoDeviceSelected;
    delete window.setMockDeviceStatusCheckingIfDeviceIsAbleToPay;
    delete window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayError;
    delete window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled;
    delete window.setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout;
    delete window.setMockDeviceStatusDeviceNotAbleToPay;
    delete window.setMockDeviceStatusDeviceAbleToPay;
  },

  /**
   * Resets device status related attributes to what their starting values should be
   * @method resetForNewDeviceStatusRetrieval
   */
  resetForNewDeviceStatusRetrieval: function() {
    this.unset('deviceStatus');
  },

  /**
   * returns a device status promise to initiate promise string after get status completes
   * @method getDeviceStatusPromise
   * @returns {*}
   */
  getDeviceStatusPromise: function() {
    return this._deviceStatusDeferred.promise();
  },

  /**
   * Resets device payment related attributes to what their starting values should be
   * @method resetForNewDevicePayment
   */
  resetForNewDevicePayment: function() {
    this.unset('error');
    this.set('canceled', false);
  },

  /**
   * returns a device payment promise to initiate promise string after payment completes
   * @method getDevicePaymentPromise
   * @returns {*}
   */
  getDevicePaymentPromise: function() {
    return this._devicePaymentDeferred.promise();
  },

  /* jshint ignore:start */

  /**
   * Checks the current status of selected payment devices
   * @method getDeviceStatus
   */
  _getDeviceStatus: function() {
    var selectedDeviceStatus;
    if (doesDevicePaymentJavascriptInterfaceExist('getIsPaymentDataDeviceAvailable')) {
      selectedDeviceStatus = DevicePaymentJavascriptInterface.getIsPaymentDataDeviceAvailable();
    } else {
      selectedDeviceStatus = this._getMockDeviceStatus();
    }
    return selectedDeviceStatus;
  },

  /**
   * Determines if tablet has any selected devices
   * @method startDeviceAvailabilityRetrieval
   */
  startDeviceAvailabilityRetrieval: function(processor) {
    this._deviceStatusDeferred = $.Deferred();

    this.resetForNewDeviceStatusRetrieval();

    if (doesDevicePaymentJavascriptInterfaceExist('startCheckingPaymentDataDeviceAvailability')) {
      DevicePaymentJavascriptInterface.startCheckingPaymentDataDeviceAvailability(processor, DEVICE_STATUS_TIMEOUT_MS);
    } else {
      this._startMockDeviceStatusRetrieval(DEVICE_STATUS_TIMEOUT_MS);
    }
    return this._startStatusPolling();
  },

  /**
   * Starts polling the android app for device payment status
   * @method _startPaymentPolling
   * @private
   */
  _startStatusPolling: function() {
    this._clearTimeoutsAndIntervals();
    this._statusTimeoutId = window.setTimeout(this._statusTimeout, DEVICE_STATUS_POLLING_TIMEOUT_MS);
    return this._statusPoll();
  },

  /**
   * Actually perform the status poll action.
   * @method _statusPoll
   * @private
   */
  _statusPoll: function() {
    var deviceStatus = this._getDeviceStatus();
    // if the device status scanning is in progress, keep polling
    this.set('paymentDataDevice.availability', deviceStatus);
    if (deviceStatus === DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE
        || deviceStatus === DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY) {
      // Always clear the timeout when setting a new timeout.
      window.clearTimeout(this._statusPollingId);
      delete this._statusPollingId;
      this._statusPollingId = window.setTimeout(this._statusPoll, POLLING_INTERVAL);
      return this._deviceStatusDeferred;
    }

    this._clearTimeoutsAndIntervals();
    if (deviceStatus === DEVICE_SCAN_STATUS.DEVICE_ABLE_TO_PAY) {
      this._deviceStatusDeferred.resolve(deviceStatus);
    } else {
      this._deviceStatusDeferred.reject(deviceStatus);
    }
    return this._deviceStatusDeferred;
  },

  /**
   * Set availability status to timeout.
   * @method _statusTimeout
   * @private
   */
  _statusTimeout: function() {
    this._clearTimeoutsAndIntervals();
    var timeoutStatus;
    if (!this.isPaymentDataDeviceEnabled()) {
      timeoutStatus = DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_TIMEOUT;
    } else {
      timeoutStatus = DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT;
    }
    this.set('paymentDataDevice.availability', timeoutStatus);
    this._deviceStatusDeferred.reject(timeoutStatus);
  },

  /**
   * Clear the current payment data device availability so that it can be fetched freshly.
   * @method clearPaymentDataDeviceAvailability
   */
  clearPaymentDataDeviceAvailability: function() {
    this.unset('paymentDataDevice.availability');
  },

  /**
   * @method hasSelectedPaymentDataDevice
   * return {Boolean} true if there is a selected payment device, false otherwise.
   */
  hasSelectedPaymentDataDevice: function() {
    return this.get('paymentDataDevice.availability') === DEVICE_SCAN_STATUS.DEVICE_ABLE_TO_PAY;
  },

  /**
   * @method isPaymentDataDeviceNotFound
   * @return {Boolean} true if the device was not found after scanning has completed, false otherwise.
   */
  isPaymentDataDeviceNotFound: function() {
    var paymentDataDeviceSelectedStatus = paymentDataDeviceService.get('paymentDataDevice.availability');
    return paymentDataDeviceSelectedStatus === paymentDataDeviceService.DEVICE_SCAN_STATUS.DEVICE_NOT_ABLE_TO_PAY
           || paymentDataDeviceSelectedStatus === paymentDataDeviceService.DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_ERROR
           || paymentDataDeviceSelectedStatus === paymentDataDeviceService.DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_CANCELED
           || paymentDataDeviceSelectedStatus === paymentDataDeviceService.DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT;
  },

  /**
   * @return {Boolean} true if a payment data device is selected (i.e. not looking for selected device and the process was successful), false otherwise.
   */
  isPaymentDataDeviceEnabled: function() {
    var paymentDataDeviceSelectedStatus = paymentDataDeviceService.get('paymentDataDevice.availability');
    return this._isPaymentDataDeviceEnabledStatus(paymentDataDeviceSelectedStatus);
  },

  /**
   * Starts the device payment and polling
   * @method _startDevicePaymentAndPolling
   * @param paymentTransactionModel {PaymentTransactionModel} the payment transaction information.
   */
  startDevicePaymentAndPolling: function(paymentTransactionModel) {
    this._devicePaymentDeferred = $.Deferred();

    this.resetForNewDevicePayment();
    this.set('devicePaymentFinished', false);
    if (doesDevicePaymentJavascriptInterfaceExist('resetDevicePayment', 'startDevicePayment')) {
      DevicePaymentJavascriptInterface.resetDevicePayment();
      DevicePaymentJavascriptInterface.startDevicePayment(DEVICE_PAYMENT_TIMEOUT_MS, JSON.stringify(paymentTransactionModel.toJSON()));
    } else {
      this._startMockDevicePayment(DEVICE_PAYMENT_TIMEOUT_MS);
    }
    return this._startPaymentPolling();
  },

  /**
   * Starts polling the android app for device payment status
   * @method _startPaymentPolling
   * @private
   */
  _startPaymentPolling: function() {
    this._clearTimeoutsAndIntervals();
    this._timeoutId = window.setTimeout(this._timeout, DEVICE_PAYMENT_POLLING_TIMEOUT_MS);
    return this._pollForPayment();
  },

  /**
   * Actually perform the poll action.
   * @method _pollForPayment
   * @private
   */
  _pollForPayment: function() {
    var devicePaymentStatus = this._getDeviceStatusPayment();
    // if the device payment is in progress, keep polling
    if (devicePaymentStatus === DEVICE_PAYMENT_STATUS.IN_PROGRESS) {
      // Always clear the timeout when setting a new timeout.
      window.clearTimeout(this._paymentPollingId);
      delete this._paymentPollingId;
      this._paymentPollingId = window.setTimeout(this._pollForPayment, POLLING_INTERVAL);
      return this._devicePaymentDeferred;
    }

    this._clearTimeoutsAndIntervals();
    if (devicePaymentStatus === DEVICE_PAYMENT_STATUS.FINISHED) {
      var transactionVecnaId = this._getTransactionVecnaId();
      if (!transactionVecnaId) {
        this.set('error', PAYMENT_ERRORS.NO_DATA);
        this._devicePaymentDeferred.reject(PAYMENT_ERRORS.NO_DATA);
      } else {
        this.set('transactionVecnaId', transactionVecnaId);
        this._devicePaymentDeferred.resolve(transactionVecnaId);
      }
    } else if (devicePaymentStatus === DEVICE_PAYMENT_STATUS.CANCELED) {
      this.set('canceled', true);
      this._devicePaymentDeferred.reject(PAYMENT_ERRORS.PAYMENT_CANCELED);
    } else if (devicePaymentStatus === DEVICE_PAYMENT_STATUS.ERROR) {
      this.set('error', PAYMENT_ERRORS.PAYMENT_ERROR);
      this._devicePaymentDeferred.reject(PAYMENT_ERRORS.PAYMENT_ERROR);
    } else if (devicePaymentStatus === DEVICE_PAYMENT_STATUS.TIMEOUT) {
      this._timeout();
    } else {
      this.set('error', PAYMENT_ERRORS.UNKNOWN_STATUS);
      this._devicePaymentDeferred.reject(PAYMENT_ERRORS.UNKNOWN_STATUS);
    }
    return this._devicePaymentDeferred;
  },

  /**
   * Set error to no data and timeout.
   * @private
   */
  _timeout: function() {
    this._clearTimeoutsAndIntervals();
    this.set('error', PAYMENT_ERRORS.TIMEOUT);
    this._devicePaymentDeferred.reject(PAYMENT_ERRORS.TIMEOUT);
  },

  /**
   * @method _getDeviceStatusPayment
   * @return {String} the status of the current device payment.  Will return a mock value if the DevicePaymentJavascriptInterface isn't available.
   * @private
   */
  _getDeviceStatusPayment: function() {
    var devicePaymentStatus;
    if (doesDevicePaymentJavascriptInterfaceExist('getDevicePaymentStatus')) {
      devicePaymentStatus = DevicePaymentJavascriptInterface.getDevicePaymentStatus();
    } else {
      devicePaymentStatus = this._getMockDevicePaymentStatus();
    }
    return devicePaymentStatus;
  },

  /**
   * Get the vecna id of the current transaction
   * @method _getTransactionVecnaId
   * @return {String} the vecna id of the current transaction.
   * @private
   */
  _getTransactionVecnaId: function() {
    var transactionVecnaId;
    if (doesDevicePaymentJavascriptInterfaceExist('getPaymentTransactionVecnaId')) {
      transactionVecnaId = DevicePaymentJavascriptInterface.getPaymentTransactionVecnaId();
    }
    return transactionVecnaId;
  },

  /**
   * Start a mock device payment process if DevicePaymentJavascriptInterface isn't available.
   * @method _startMockDevicePayment
   * @param devicePaymentTimeout {Number} the number of ms to wait for a value before timing out the mock process.
   * @private
   */
  _startMockDevicePayment: function(devicePaymentTimeout) {
    this.unset('mockDevicePaymentInfo');
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.IN_PROGRESS);
    this._mockDevicePaymentTimeoutId = window.setTimeout(this._timeoutMock, devicePaymentTimeout);
  },

  /**
   * Start a mock device status retrieval process if DevicePaymentJavascriptInterface isn't available.
   * @method _startMockDeviceStatusRetrieval
   * @param deviceStatusTimeout {Number} the number of ms to wait for a value before timing out the mock process.
   * @private
   */
  _startMockDeviceStatusRetrieval: function(deviceStatusTimeout) {
    this.set('mockPaymentDataDeviceStatus', DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE);
    this._mockPaymentDataDeviceStatusTimeout = window.setTimeout(this._timeoutMock, deviceStatusTimeout);
  },

  /**
   * Mock version of timeout that sets the mock status.
   * @method _timeoutMock
   * @private
   */
  _timeoutMock: function() {
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.TIMEOUT);
    // This is to handle the case where we are in mock mode because the app does not have the methods defined.
    // Default is to keep us in a state where the device option is not shown until we get some indication that
    // a device is selected (either by running a mock method or by the actual app returning something).
    var timeoutStatus;
    if (!this._isMockPaymentDataDeviceEnabled()) {
      timeoutStatus = DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_TIMEOUT;
    } else {
      timeoutStatus = DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT;
    }
    this.set('mockPaymentDataDeviceStatus', timeoutStatus);
  },

  /**
   * @return {Boolean} true if a payment data device is selected (i.e. not looking for selected device and the process was successful), false otherwise.
   */
  _isPaymentDataDeviceEnabledStatus: function (paymentDataDeviceSelectedStatus) {
    return paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.NOT_SCANNED
        && paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE
        && paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_ERROR
        && paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_CANCELED
        && paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_TIMEOUT
        && paymentDataDeviceSelectedStatus !== paymentDataDeviceService.DEVICE_SCAN_STATUS.NO_DEVICE_SELECTED;
  },

  /**
   * @return {Boolean} true if a payment data device is selected (i.e. not looking for selected device and the process was successful), false otherwise.
   */
  _isMockPaymentDataDeviceEnabled: function() {
    var paymentDataDeviceSelectedStatus = paymentDataDeviceService.get('mockPaymentDataDeviceStatus');
    return this._isPaymentDataDeviceEnabledStatus(paymentDataDeviceSelectedStatus);
  },

  /**
   * Globally exposed function to set device payment info for testing.
   * @method _setMockDevicePaymentInfo
   * @param devicePaymentInfo {String} the devicePayment info to set in the form: '<patientVecnaId>^<appointmentVecnaId>'
   * @private
   */
  _setMockDevicePaymentInfo: function(devicePaymentInfo) {
    this.set('mockDevicePaymentInfo', devicePaymentInfo);
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.FINISHED);
  },

  /**
   * Globally exposed function to set a canceled status for testing.
   * @method _setMockDevicePaymentCanceled
   * @private
   */
  _setMockDevicePaymentCanceled: function() {
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.CANCELED);
  },

  /**
   * Globally exposed function to set a timeout status for testing.
   * @method _setMockDevicePaymentTimeout
   * @private
   */
  _setMockDevicePaymentTimeout: function() {
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.TIMEOUT);
  },

  /**
   * Globally exposed function to set an errored status for testing.
   * @method _setMockDevicePaymentErrored
   * @private
   */
  _setMockDevicePaymentErrored: function() {
    this.set('mockDevicePaymentStatus', DEVICE_PAYMENT_STATUS.ERROR);
  },

  /**
   * Globally exposed function to set arbitrary statuses for testing.
   * @method _setMockDeviceStatus
   * @param status {String} the status to set one from DEVICE_SCAN_STATUS
   * @private
   */
  _setMockDeviceStatus: function(status) {
    this.set('mockPaymentDataDeviceStatus', status);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.NOT_SCANNED state.
   * @method _setMockDeviceStatusNotScanned
   * @private
   */
  _setMockDeviceStatusNotScanned: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.NOT_SCANNED);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE state.
   * @method _setMockDeviceStatusGettingSelectedDevice
   * @private
   */
  _setMockDeviceStatusGettingSelectedDevice: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_ERROR state.
   * @method _setMockDeviceStatusGettingSelectedDeviceError
   * @private
   */
  _setMockDeviceStatusGettingSelectedDeviceError: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_ERROR);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_CANCELED state.
   * @method _setMockDeviceStatusGettingSelectedDeviceCanceled
   * @private
   */
  _setMockDeviceStatusGettingSelectedDeviceCanceled: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_CANCELED);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_TIMEOUT state.
   * @method _setMockDeviceStatusGettingSelectedDeviceTimeout
   * @private
   */
  _setMockDeviceStatusGettingSelectedDeviceTimeout: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.GETTING_SELECTED_DEVICE_TIMEOUT);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.NO_DEVICE_SELECTED state.
   * @method _setMockDeviceStatusNoDeviceSelected
   * @private
   */
  _setMockDeviceStatusNoDeviceSelected: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.NO_DEVICE_SELECTED);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY state.
   * @method _setMockDeviceStatusCheckingIfDeviceIsAbleToPay
   * @private
   */
  _setMockDeviceStatusCheckingIfDeviceIsAbleToPay: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_ERROR state.
   * @method _setMockDeviceStatusCheckingIfDeviceIsAbleToPayError
   * @private
   */
  _setMockDeviceStatusCheckingIfDeviceIsAbleToPayError: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_ERROR);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_CANCELED state.
   * @method _setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled
   * @private
   */
  _setMockDeviceStatusCheckingIfDeviceIsAbleToPayCanceled: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_CANCELED);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT state.
   * @method _setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout
   * @private
   */
  _setMockDeviceStatusCheckingIfDeviceIsAbleToPayTimeout: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.CHECKING_IF_DEVICE_IS_ABLE_TO_PAY_TIMEOUT);
  },

  /**
   * Globally exposed function to set the DEVICE_SCAN_STATUS.DEVICE_NOT_ABLE_TO_PAY state.
   * @method _setMockDeviceStatusDeviceNotAbleToPay
   * @private
   */
  _setMockDeviceStatusDeviceNotAbleToPay: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.DEVICE_NOT_ABLE_TO_PAY);
  },

  /**
   * Globally exposed function to set a device connected status for testing
   * @method _setMockDeviceStatusDeviceAbleToPay
   * @private
   */
  _setMockDeviceStatusDeviceAbleToPay: function() {
    this._setMockDeviceStatus(DEVICE_SCAN_STATUS.DEVICE_ABLE_TO_PAY);
  },

  /* jshint ignore:end */

  /**
   * Clears the timeouts and intervals setup by this service.
   * @method _clearTimeoutsAndIntervals
   * @private
   */
  _clearTimeoutsAndIntervals: function() {
    window.clearInterval(this._statusPollingId);
    window.clearTimeout(this._statusTimeoutId);
    window.clearInterval(this._paymentPollingId);
    window.clearTimeout(this._timeoutId);
    this._clearMockDevicePaymentTimeouts();
  },


  /**
   * Clears the timeouts associated with the mock device payment process.
   * @method _clearMockDevicePaymentTimeouts
   * @private
   */
  _clearMockDevicePaymentTimeouts: function() {
    window.clearTimeout(this._mockDevicePaymentTimeoutId);
    window.clearTimeout(this._mockPaymentDataDeviceStatusTimeout);
  },


  /**
   * Get the mock devicePayment info if it is set.
   * @method _getMockDevicePaymentInfo
   * @return {String} the device payment info as key value pairs that will be handled by the payment processor.
   *         Tempus key values: 'ksn', 'sessionId', 'encryptedTrack1', 'encryptedTrack2', 'deviceSerial', 'magnePrint', 'magneStatus'
   *         Example:
   *         {
   *           ksn: "9012020B47A34C00001D",
   *           sessionId: "DA8823FC6E1FF1A6",
   *           deviceSerial: "abc123",
   *           encryptedTrack1: "0BBE5542671F1B72B12EFF8276E84B69901C96E0F518D5D451E6072708F765BD483572F5FC8A9C02F49F371C54CE548DD6D3C29BAC47390DE76D9451AFEB08CF608C14DDFA97094A6672B2E212FEB96B",
   *           encryptedTrack2: "F28E33E9AFB65FFAD61811375CAB0A12C3920CE50DC307778145D6C12F051059407934E50C80A699"
   *         }
   * @private
   * @private
   */
  _getMockDevicePaymentInfo: function() {
    return this.get('mockDevicePaymentInfo');
  },

  /**
   * Get the mock device payment status.
   * @method _getMockDevicePaymentStatus
   * @return {DEVICE_PAYMENT_STATUS} the status of the mock device payment.
   * @private
   */
  _getMockDevicePaymentStatus: function() {
    return this.get('mockDevicePaymentStatus');
  },

  /**
   * Get the mock device status.
   * @method _getMockDeviceStatus
   * @return {DEVICE_PAYMENT_STATUS} the status of the mock device.
   * @private
   */
  _getMockDeviceStatus: function() {
    return this.get('mockPaymentDataDeviceStatus');
  }

}))();
paymentDataDeviceService.PAYMENT_ERRORS = PAYMENT_ERRORS;
paymentDataDeviceService.DEVICE_SCAN_STATUS = DEVICE_SCAN_STATUS;
module.exports = paymentDataDeviceService;
